<template>
  <div id="settingsMobileApp">
    <div class="container">
      <Tabs>

        <TabSection :title="$t('mobileApp')">
          <div class="columns">
            <div class="column">
              <div class="subtitle">iOS</div>
              <div class="group">
                <label for="txtIosVersion">{{ $t('version') }}</label>
                <input id="txtIosVersion" type="text" v-model="config.ios.version">
              </div>
              <div class="group">
                <label for="txtUrl">{{ $t('app-url') }}</label>
                <input id="txtUrl" type="text" v-model="config.ios.url">
              </div>
            </div>
            <div class="column">
              <div class="subtitle">Android</div>
              <div class="group">
                <label for="txtAndroidVersion">{{ $t('version') }}</label>
                <input id="txtAndroidVersion" type="text" v-model="config.android.version">
              </div>
              <div class="group">
                <label for="txtAndroidUrl">{{ $t('app-url') }}</label>
                <input id="txtAndroidUrl" type="text" v-model="config.android.url">
              </div>
            </div>
          </div>
        </TabSection>

      </Tabs>

      <div class="footer-actions">
        <button class="btn btn-primary" @click="save">{{ $t("save") }}</button>
      </div>

    </div>
  </div>
</template>

<script>
  import { mapActions } from "vuex";

  export default {
    name: "SettingsMobileApp",

    data() {
      return {
        parentConfig: {},
        config: {},
        branchId: null,
        companyId: null,
        ready: false
      }
    },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "settings.mobileapp";
      this.$store.state.pageIcon = "/icon/mobile.svg";

      this.branchId = this.$route.query.branch;

      if (this.branchId) {
        await this.getBranchConfig();
      } else {
        this.$router.push("/");
      }
    },

    methods: {

      ...mapActions([
        "getBranchParentConfiguration", "getBranch", "saveBranch"
      ]),

      async getBranchConfig() {
        let config = await this.getBranch({ branchId: this.branchId, fallback: true });
        this.config = config.mobileApp;
        let parentConfig = await this.getBranchParentConfiguration({ branchId: this.branchId });
        this.parentConfig = parentConfig.mobileApp;
        this.ready = true;
      },

      async save() {
        if (this.branchId) {
          let response = await this.saveBranch({
            branchId: this.branchId,
            data: { mobileApp: this.config }
          });
          if (response) {
            toast(this.$t("branch.success"), "success");
          } else {
            toast(this.$t("error.no_server"), "error");
          }
        }
      },

    }

  }
</script>

<style lang="scss" scoped>
  #settingsMobileApp {
    display: flex;
  }
</style>